import { BsLink45Deg } from "react-icons/bs";
import { BiDetail } from "react-icons/bi";
import { FaUser, FaProjectDiagram, FaHistory } from "react-icons/fa";
import { GrDocumentTime, GrMoney } from "react-icons/gr";
import { ImInsertTemplate } from "react-icons/im";
import { IconContext } from "react-icons";
import { NavLink } from "react-router-dom";
import Tooltip from "../../../components/tooltip/Tooltip";
import "../Sidebar.css";
import { getSessionItem } from "../../../utils/helper/session";
import { useMemo } from "react";
import { HiOutlineWallet } from "react-icons/hi2";
import { FaChartLine } from "react-icons/fa";

function TeamLeaderSidebar() {
  const user = getSessionItem("User");

  const value = useMemo(() => ({
    color: "gray",
    size: "40px",
  }), []);

  return (
    <nav className="sidebar" id="manager-sidebar">
      <IconContext.Provider value={value}>
        <div className="team-nav-group nav-group">
          <div>
            <Tooltip content="Manager Dashboard" direction="right">
              <NavLink
                to="/manager"
                className={({ isActive }) => (isActive ? "active" : "")}
                end
              >
                <ImInsertTemplate />
              </NavLink>
            </Tooltip>

            <Tooltip content="Payroll Details" direction="right">
              <NavLink
                to="/manager/payroll-details"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <GrMoney />
              </NavLink>
            </Tooltip>

            <Tooltip content="Project Details" direction="right">
              <NavLink
                to="/manager/projects"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <FaProjectDiagram />
              </NavLink>
            </Tooltip>

            <Tooltip content="Manual Time Approval" direction="right">
              <NavLink
                to="/manager/manual-time-approval"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <FaHistory />
              </NavLink>
            </Tooltip>

          </div>
        </div>

        <div className="team-nav-group nav-group" id="step-sidebar">
          <div>
            <Tooltip content="My Dashboard" direction="right">
              <NavLink
                to="/summary"
                className={({ isActive }) => (isActive ? "active" : "")}
                end
              >
                <ImInsertTemplate />
              </NavLink>
            </Tooltip>

            <Tooltip content="My Daily Diary" direction="right">
              <NavLink
                to="/diary"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <BiDetail />
              </NavLink>
            </Tooltip>

            <div id="step-3">
              <Tooltip content="My Info" direction="right">
                <NavLink
                  to="/profile/info"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <FaUser />
                </NavLink>
              </Tooltip>
            </div>

            <div id="step-3">
                <Tooltip content="My payments" direction="right">
                  <NavLink
                    to="/profile/payment"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <HiOutlineWallet />
                  </NavLink>
                </Tooltip>
              </div>

            {!user.disabled && (
              <Tooltip content="Links" direction="right">
                <NavLink
                  to="/profile/links"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <BsLink45Deg />
                </NavLink>
              </Tooltip>
            )}

            <Tooltip content="My Requests" direction="right">
              <NavLink
                to="/profile/requests"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <GrDocumentTime />
              </NavLink>
            </Tooltip>

            <Tooltip
              content="My Growth"
              direction="right"
            >
              <NavLink
                to="/profile/growth"
                className={({ isActive }) =>
                  isActive ? "active" : ""
                }
              >
                <FaChartLine />
              </NavLink>
            </Tooltip>
          </div>
        </div>
      </IconContext.Provider>
    </nav>
  );
}

export default TeamLeaderSidebar;
